// extracted by mini-css-extract-plugin
module.exports = {"root":"components-ui-range-root","min":"components-ui-range-min","input":"components-ui-range-input"};